import KeyLogs from './KeyLogs';
import KeyLogDetails from './KeyLogDetails';

export {KeyLogs, KeyLogDetails};
